import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";

@customElement("suggestions-page")
export class SuggestionsPage extends LitElement {
  @property() boardUrl = "";

  protected createRenderRoot() { return this; }

  render() {
    const boardUrl = this.boardUrl.trim();
    return html`
      <main class="suggestions-page">
        <header class="suggestions-hero">
          <span class="eyebrow">Help choose what comes next</span>
          <h1>Shape what<br>we hear next.</h1>
          <p class="lede">Request a song study, propose a feature, or vote for an idea that is already here. Popular requests help set the Ghostbeats roadmap.</p>
        </header>

        <section class="suggestion-paths" aria-label="Kinds of suggestions">
          <a href=${boardUrl} target="_blank" rel="noopener">
            <span class="suggestion-number">01</span>
            <div><h2>Request a song study</h2><p>Start the title with “Song:” then name the band and track. Tell us which drum moment deserves a four-bar study—and include a timestamp if you have one.</p></div>
            <b>Browse and request ↗</b>
          </a>
          <a href=${boardUrl} target="_blank" rel="noopener">
            <span class="suggestion-number">02</span>
            <div><h2>Suggest a feature</h2><p>Start the title with “Feature:” then tell us what you want to hear, compare, change, or understand that Ghostbeats does not make possible yet.</p></div>
            <b>Browse and suggest ↗</b>
          </a>
        </section>

        <section id="suggestion-board" class="suggestion-board" aria-labelledby="suggestion-board-heading">
          <div class="suggestion-board-heading">
            <div><span class="eyebrow">Community requests</span><h2 id="suggestion-board-heading">Browse before you post.</h2></div>
            <p>Vote when someone has already suggested your idea. Add a new request when they have not.</p>
          </div>
          <div class="suggestion-handoff">
            <div class="suggestion-handoff-copy">
              <span class="suggestion-number">GB</span>
              <div><h3>One board. Two clear prefixes.</h3><p>Look for <b>Song:</b> and <b>Feature:</b> titles. Vote for an existing request when it matches yours, or create a new post when it does not.</p></div>
            </div>
            <a class="button primary" href=${boardUrl} target="_blank" rel="noopener">Open the request board ↗</a>
            <small>Opens the Ghostbeats community board in a new tab. No account is required to post or vote.</small>
          </div>
        </section>
      </main>
    `;
  }
}
